export { default as HtmlTablePastePlugin } from './HtmlTablePastePlugin';
